export const SKILL_FILE_NAME = 'SKILL.md';

export const SKILL_NAME_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const SKILL_LIMITS = {
  nameChars: 64,
  descriptionChars: 1024,
  compatibilityChars: 500,
  maxFiles: 200,
  maxFileBytes: 512 * 1024,
  maxTotalBytes: 2 * 1024 * 1024,
  maxPathChars: 200,
  maxPathDepth: 6,
} as const;
